module.exports = __webpack_public_path__ + "static/media/sliderimg2.cf8e42a8.webp";